import { render, staticRenderFns } from "./DataObjects.vue?vue&type=template&id=68690c1e&"
import script from "./DataObjects.vue?vue&type=script&lang=js&"
export * from "./DataObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports